import { Injectable } from '@angular/core';
// import { io } from 'socket.io-client';
import { Observable } from 'rxjs';
import { UserApi } from '../services/user-api.service';
import { environment } from '../../../../environments/environment';

 declare const io: any;

@Injectable({
  providedIn: 'root'
})
export class DriversTrackingService {
  socket: any;

  constructor(private userApi: UserApi) {
    this.socket = io(environment.socket_url, {
      query: {
        'token': `Bearer ${this.userApi.currentUser$.value.accessToken}`
      }
    });
  }

  listen(eventName: string) {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }

}
